import React from 'react'
import { icons } from '../../../assets/icons'
import { Wrapper } from './NormalButton.style'

NormalButton.defaultProps = {
  id: '',
  label: 'Button',
  type: 'button-primary',
  disabled: false,
  loading: false,
  hideIcon: false,
}

type NormalButtonProps = {
  id?: string
  label?: string
  type?: 'button-primary' | 'button-secondary'
  onClick?: (value: any) => void
  disabled?: boolean
  loading?: boolean
  hideIcon?: boolean
  className?: string
}

function NormalButton({
  id,
  label,
  type,
  className,
  disabled,
  loading,
  hideIcon,
  onClick,
}: NormalButtonProps) {
  return (
    <Wrapper
      className={className}
      id={id}
      type={type}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
    >
      {!(disabled && loading) ? label : 'Please wait...'}

      {disabled && loading ? (
        <img style={{ width: 20, marginLeft: 20 }} src={icons.iconLoader} alt="Loader" />
      ) : (
        <>
          {!hideIcon && (
            <img style={{ width: 20, marginLeft: 20 }} src={icons.iconButtonAction} alt="Action" />
          )}
        </>
      )}
    </Wrapper>
  )
}

export default NormalButton
